import script from "./RoomForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomForm.vue?vue&type=script&setup=true&lang=ts"

import "./RoomForm.vue?vue&type=style&index=0&id=5334ea9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5334ea9f"]])

export default __exports__